import type { InterventionProps } from "@simplybusiness/mobius-interventions";
import {
  InterventionWrapper,
  PricingNudgeIntervention,
} from "@simplybusiness/mobius-interventions";
import type { WithMetadata } from "../../pages";
import type { IndicativePricingModalInterventionProps } from "./types";

const IndicativePricingModalInterventionInner = (props: InterventionProps) => {
  const hasIndicativePricing = props.data?.component_names?.some(name =>
    name.includes("indicative-pricing"),
  );

  return hasIndicativePricing ? (
    <PricingNudgeIntervention {...props} />
  ) : (
    <div data-testid="indicative-pricing-modal-intervention-control" />
  );
};

const IndicativePricingModalIntervention = (
  _props: WithMetadata<IndicativePricingModalInterventionProps>,
) => {
  return (
    <div data-testid="indicative-pricing-modal-intervention">
      <InterventionWrapper name="indicative-pricing-hydra-gpt">
        <IndicativePricingModalInterventionInner />
      </InterventionWrapper>
    </div>
  );
};

export { IndicativePricingModalIntervention };
